export default __webpack_public_path__ + "static/media/rate_selffix_logo.03cc282d.png";